export default __webpack_public_path__ + "static/media/graph.2db40efd.svg";